export default __webpack_public_path__ + "static/media/video.d973f197.svg";